import React, { useEffect, useState } from 'react';
import { AwardIcon } from 'lucide-react';
export const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-[#0F1115]/90 backdrop-blur-md border-b border-gray-800' : 'bg-transparent'}`} data-id="element-63">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-64">
        <div className="flex items-center justify-between h-20" data-id="element-65">
          {/* Logo */}
          <div className="flex items-center gap-3 group cursor-default" data-id="element-66">
            <div className="w-[60px] h-[60px] bg-white rounded-xl flex items-center justify-center shadow-lg group-hover:shadow-red-500/20 transition-all duration-300" data-id="element-67">
              <AwardIcon className="w-9 h-9 text-[#d73b3e]" data-id="element-68" />
            </div>
            <span className="font-display font-bold text-3xl text-white tracking-tight" data-id="element-69">
              Certified<span className="text-[#d73b3e]" data-id="element-70">Devs</span>
            </span>
          </div>
        </div>
      </div>
    </header>;
};